const PAGE_CONSTANTS = {
  YOUR_APPOINTMENT_CONFIRMED_TITLE:
    "Your appointment request has been submitted.",
  YOUR_TELE_MER_CONFIRMED_TITLE: "Your request has been submitted.",
  APPLICATION_TRACKER: "Application Tracker",
  TELE_MEDICAL_BOOKING: "Tele MER Call Scheduling",
  ALLOWED_MAX_TIMING_FIVE_PM: "5:00 PM",
  ALLOWED_TIMING_ELEVEN_AM: "11:00 AM",
  TPA_HA: "HA",
  TPA_HI: "HI",
  TPA_VH: "VH",
  MERIDIEM_AM: "AM",
  MERIDIEM_PM: "PM",
  TIME_CONFIG: {
    AM: ["07", "08", "09", "10", "11"],
    PM: ["12", "01", "02", "03", "04", "05"],
  },
  TELE_TIME_CONFIG: {
    AM: ["09", "10", "11"],
    PM: ["12", "01", "02", "03", "04", "05", "06", "07", "08"],
  },
  PRIORITY_INDEX: {
    FIRST: 0,
    SECOND: 1,
    THIRD: 2,
  },
  LANGUAGE_DROPDOWN_OPTIONS_HA: [
    { label: "English", value: "English" },
    { label: "Hindi", value: "Hindi" },
    { label: "Marathi", value: "Marathi" },
    { label: "Gujarati", value: "Gujarati" },
    { label: "Malayalam", value: "Malayalam" },
    { label: "Tamil", value: "Tamil" },
    { label: "Telugu", value: "Telugu" },
    { label: "Kannada", value: "Kannada" },
    { label: "Punjabi", value: "Punjabi" },
    { label: "Bengali", value: "Bengali" },
    { label: "Assamese", value: "Assamese" },
    { label: "Odiya", value: "Odiya" },
    { label: "Assami", value: "Assami" },
    { label: "Oriana", value: "Oriana" },
    { label: "Marwadi", value: "Marwadi" },
    { label: "Others", value: "Others" }
  ],
  LANGUAGE_DROPDOWN_OPTIONS_HI: [
    { label: "English", value: "ENGLISH" },
    { label: "Hindi", value: "HINDI" },
    { label: "Marathi", value: "MARATHI" },
    { label: "Bengali", value: "BENGALI" },
    { label: "Gujarati", value: "GUJARATI" },
    { label: "Tamil", value: "TAMIL" },
    { label: "Telugu", value: "TELUGU" },
    { label: "Malayalam", value: "MALYALAM" },
    { label: "Kannada", value: "KANNADA" }
  ],
  LANGUAGE_DROPDOWN_OPTIONS_VH: [
    { label: "English", value: "ENGLISH" },
    { label: "Hindi", value: "HINDI" },
    { label: "Marathi", value: "MARATHI" },
    { label: "Bengali", value: "BENGALI" },
    { label: "Gujarati", value: "GUJARATI" },
    { label: "Tamil", value: "TAMIL" },
    { label: "Telugu", value: "TELUGU" },
    { label: "Malayalam", value: "MALYALAM" },
    { label: "Kannada", value: "KANNADA" },
    { label: "Punjabi", value: "PUNJABI" },
    { label: "Assamese", value: "Assamese" },
    { label: "Oriya", value: "Oriya" }
  ],  
};

export default PAGE_CONSTANTS;
